module.exports = __webpack_public_path__ + "static/media/prop-1.aef7bd09.png";